const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { gql } from '@apollo/client';
import { PROPERTY_FIELDS_FRAGMENT } from './SubscriptionFragments';
export const LINE_ITEMS_DEFAULT_ASSOCIATIONS_FRAGMENT = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"LineItemDefaultAssociations\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"DefaultCrmObject\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultAssociations\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toLineItems\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"first\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"200\"}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"edges\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"node\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"amount\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"createdate\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"discount\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_cost_of_goods_sold\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_discount_percentage\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_line_item_currency_code\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_position_on_quote\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"price\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"quantity\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"recurringbillingfrequency\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"tax\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"timestamp\"}}]}}]}}]}}]}}]}}]}}]}}]}", {
  kind: "Document",
  definitions: _unique([{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "LineItemDefaultAssociations"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "DefaultCrmObject"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "defaultAssociations"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "toLineItems"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "first"
              },
              value: {
                kind: "IntValue",
                value: "200"
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "edges"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "node"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "defaultProperties"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "amount"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "createdate"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "discount"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_cost_of_goods_sold"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_discount_percentage"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_line_item_currency_code"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_position_on_quote"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "price"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "quantity"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "recurringbillingfrequency"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "tax"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "timestamp"
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }].concat(PROPERTY_FIELDS_FRAGMENT.definitions))
});
export const PAYMENT_SUBSCRIPTION_ASSOCIATIONS_LINE_ITEM_FRAGMENT = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PaymentSubscriptionLineItemAssociations\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PaymentsSubscription\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associations\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toUpcomingLineItems\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"first\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"10\"}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"edges\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"node\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"amount\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"createdate\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"discount\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_cost_of_goods_sold\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_discount_percentage\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_line_item_currency_code\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hs_position_on_quote\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"price\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"quantity\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"recurringbillingfrequency\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"tax\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyFieldsFragment\"}}]}}]}}]}}]}}]}}]}}]}}]}", {
  kind: "Document",
  definitions: _unique([{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "PaymentSubscriptionLineItemAssociations"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PaymentsSubscription"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "associations"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "toUpcomingLineItems"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "first"
              },
              value: {
                kind: "IntValue",
                value: "10"
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "edges"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "node"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "defaultProperties"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "amount"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "createdate"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "discount"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_cost_of_goods_sold"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_discount_percentage"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_line_item_currency_code"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "hs_position_on_quote"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "price"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "quantity"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "recurringbillingfrequency"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "tax"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "FragmentSpread",
                                name: {
                                  kind: "Name",
                                  value: "PropertyFieldsFragment"
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }].concat(PROPERTY_FIELDS_FRAGMENT.definitions))
});